<div class="flex flex-col gap-3">
  @if (reminders.length) {
    <ul class="m-0 flex list-none flex-col gap-1.5 p-0">
      @for (reminder of reminders; track reminder.id) {
        <li class="flex min-w-0 items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-800">
          <app-icon
            class="!h-4 !w-4 shrink-0 !text-[16px] !leading-none"
            [ngClass]="reminder.sent_at ? 'text-emerald-500' : 'text-slate-400'"
          >
            {{ reminder.sent_at ? 'notifications_active' : 'notifications' }}
          </app-icon>
          <span class="min-w-0 flex-1 truncate">
            @if (reminder.before_deadline_minutes !== null) {
              @if (reminder.before_deadline_minutes === 0) {
                {{ 'crm_tasks.reminders.at_deadline' | translate }}
              } @else {
                @let offset = splitReminderMinutes(reminder.before_deadline_minutes);
                {{
                  'crm_tasks.reminders.before'
                    | translate
                      : { value: offset.value, unit: 'crm_tasks.reminders.unit_short.' + offset.unit | translate }
                }}
              }
              @if (reminder.remind_at) {
                <span class="text-slate-400">· {{ reminder.remind_at | date: 'dd.MM.yyyy HH:mm' }}</span>
              }
            } @else if (reminder.remind_at) {
              {{ reminder.remind_at | date: 'dd.MM.yyyy HH:mm' }}
            }
          </span>
          @if (reminder.sent_at) {
            <span
              class="shrink-0 text-xs font-medium text-emerald-600"
              [title]="reminder.sent_at | date: 'dd.MM.yyyy HH:mm'"
            >
              {{ 'crm_tasks.reminders.sent' | translate }}
            </span>
          }
          <button
            type="button"
            class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded text-slate-400 hover:bg-rose-50 hover:text-rose-600 disabled:opacity-40"
            [attr.aria-label]="'delete' | translate"
            [disabled]="busy"
            (click)="remove.emit(reminder)"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">delete</app-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <p class="m-0 text-sm text-slate-400">{{ 'crm_tasks.reminders.empty' | translate }}</p>
  }

  <div class="flex flex-col gap-2">
    <div class="flex flex-wrap items-center gap-2">
      <app-select
        class="block w-44"
        [formControl]="mode"
        [options]="modeOptions"
        optionLabel="label"
        optionValue="value"
        optionDisabled="disabled"
        [isTranslate]="true"
      />
      @if (mode.value === 'before') {
        <input
          type="number"
          min="0"
          step="1"
          class="h-10 w-20 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none focus:border-orange-400"
          [formControl]="amount"
          [attr.aria-label]="'crm_tasks.reminders.amount' | translate"
          (keydown.enter)="$event.preventDefault(); submit()"
        />
        <app-select
          class="block w-32"
          [formControl]="unit"
          [options]="unitOptions"
          optionLabel="label"
          optionValue="value"
          [isTranslate]="true"
        />
      } @else {
        <p-datepicker
          class="w-40"
          [fluid]="true"
          dataType="string"
          dateFormat="yy-mm-dd"
          [showButtonBar]="true"
          appendTo="body"
          panelStyleClass="board-v3-datepicker-panel"
          inputStyleClass="h-10 w-full rounded-lg border !border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none focus:!border-orange-400"
          [placeholder]="'date' | translate"
          [ariaLabel]="'date' | translate"
          [formControl]="date"
        />
        <p-datepicker
          class="w-28"
          dataType="string"
          [timeOnly]="true"
          hourFormat="24"
          [stepMinute]="1"
          appendTo="body"
          panelStyleClass="board-v3-datepicker-panel"
          inputStyleClass="h-10 w-full rounded-lg border !border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none focus:!border-orange-400 disabled:cursor-not-allowed disabled:bg-slate-50"
          [placeholder]="'time_label' | translate"
          [ariaLabel]="'time_label' | translate"
          [formControl]="time"
        />
      }
      <app-button btnType="stroked" [disabled]="busy" (onChangeClick)="submit()">
        <span class="flex items-center gap-1 text-sm font-semibold leading-none">
          <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">add</app-icon>
          {{ 'crm_tasks.reminders.add' | translate }}
        </span>
      </app-button>
    </div>
    @if (invalid) {
      <p class="m-0 text-xs text-red-500">
        {{
          (mode.value === 'before' ? 'crm_tasks.reminders.invalid_before' : 'crm_tasks.reminders.invalid_at')
            | translate
        }}
      </p>
    } @else if (!hasDeadline) {
      <p class="m-0 text-xs text-slate-400">{{ 'crm_tasks.reminders.no_deadline_hint' | translate }}</p>
    }
  </div>
</div>
